import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminShoppableLandings from "@/pages/admin/AdminShoppableLandings";

export const Route = createFileRoute("/admin/shoppable-landings/")({
  component: () => (
    <ProtectedRoute>
      <AdminShoppableLandings />
    </ProtectedRoute>
  ),
});
